export const setFormData = (data) => ({
  type: 'SET_FORM_DATA',
  payload: data,
});
